/**
 * v2's Button theme branched on colorScheme inside variant functions
 * (special-casing `gray` and `darkgray`). v3 recipes are static, so the
 * per-palette differences live here as semantic tokens and the recipe
 * references `colorPalette.btn*` — one static variant covers every palette.
 */
const std = (hue: string) => ({
  btnSolidBg: { value: `{colors.${hue}.500}` },
  btnSolidColor: { value: 'white' },
  btnSolidHover: { value: `{colors.${hue}.600}` },
  btnSolidActive: { value: `{colors.${hue}.700}` },
  btnGhostColor: { value: `{colors.${hue}.500}` },
  btnGhostHover: { value: `{colors.${hue}.50}` },
  btnGhostActive: { value: `{colors.${hue}.100}` },
  btnFocusRing: { value: `{colors.${hue}.200}` },
  btnOutlineBorder: { value: 'currentColor' },
  btnLinkActive: { value: `{colors.${hue}.700}` },
});

const buttonPalettes = {
  primary: std('blue'),
  blue: std('blue'),
  green: std('green'),
  success: std('green'),
  red: std('red'),
  danger: std('red'),
  orange: std('orange'),
  warning: std('orange'),
  // v2 gray branch: light bg, darker text, shifted hover/active/focus shades
  gray: {
    btnSolidBg: { value: '{colors.gray.50}' },
    btnSolidColor: { value: '{colors.gray.500}' },
    btnSolidHover: { value: '{colors.gray.100}' },
    btnSolidActive: { value: '{colors.gray.200}' },
    btnGhostColor: { value: '{colors.gray.500}' },
    btnGhostHover: { value: '{colors.gray.50}' },
    btnGhostActive: { value: '{colors.gray.200}' },
    btnFocusRing: { value: '{colors.gray.100}' },
    btnOutlineBorder: { value: '{colors.gray.200}' },
    btnLinkActive: { value: '{colors.gray.700}' },
  },
  // v2 darkgray branch: mid-gray solid with white text
  darkgray: {
    btnSolidBg: { value: '{colors.gray.400}' },
    btnSolidColor: { value: 'white' },
    btnSolidHover: { value: '{colors.gray.600}' },
    btnSolidActive: { value: '{colors.gray.700}' },
    btnGhostColor: { value: '{colors.gray.500}' },
    btnGhostHover: { value: '{colors.gray.50}' },
    btnGhostActive: { value: '{colors.gray.200}' },
    btnFocusRing: { value: '{colors.gray.200}' },
    btnOutlineBorder: { value: 'currentColor' },
    btnLinkActive: { value: '{colors.gray.700}' },
  },
};

export default buttonPalettes;
